import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;

  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 996;
  overflow-y: auto;

  background-color: ${({ theme }) => theme.panel.solid};

  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral[3]};
  border-radius: ${({ theme }) => theme.radius[5]}px;
`;

export const ContainerSecundario = styled.div`
  padding-top: ${({ theme }) => theme.spacing[6]}px;
  padding-bottom: ${({ theme }) => theme.spacing[6]}px;
  padding-left: ${({ theme }) => theme.spacing[4]}px;
  padding-right: ${({ theme }) => theme.spacing[4]}px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: ${({ theme }) => theme.spacing[4]}px;
  margin-top: ${({ theme }) => theme.spacing[4]}px;
`;
